module.exports = __webpack_public_path__ + "img/ic_close_rounded.2bbf8373.svg";